import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { fetchProjectMilestones, fetchProjectTeamMembers } from '../../../utils/fetchData';
import { selectLoader, validateTextInput } from '../../../utils/Helpers';
import appToast, { TOAST_TYPE } from '../../../utils/AppToast';
import APIServices from '../../../services/APIServices';
import plusBtn from '../../../assets/img/plus.svg';
import deleteBtn from '../../../assets/img/delete.svg';
import user from '../../../assets/img/nick-user2.png';
const ReqFeedbackModal = ({ projectId, closeModal, isInternalProject }) => {
  const [loading, setLoading] = useState(true);
  const [mileStonesList, setMileStonesList] = useState([]);
  const [selectedMilestone, setSelectedMilestone] = useState(null);
  const [description, setDescription] = useState('');
  const [clientOptions, setClientOptions] = useState([]);
  const [clients, setClients] = useState([{ id: 1, selectedClient: null }]); // Initial client row
  const [submitLoading, setSubmitLoading] = useState(false);
  const submissionInProgressRef = useRef(false);
  const [isGeneralFeedback, setGeneralFeedback] = useState(false);
  const [descLength, setDescLength] = useState(0);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    console.log(projectId);

    if (projectId) {
      fetchMilestones();
      fetchProjectTeamMembers(
        projectId,
        setClientOptions,
        isInternalProject ? '' : 'user2',
        isInternalProject ? 'internal' : 'external'
      );
    }
  }, [projectId]);

  const fetchMilestones = async () => {
    setLoading(true);
    try {
      let milestones = await fetchProjectMilestones(projectId, 'update');
      if (milestones?.length > 0) {
        const formattedPermissions = milestones.map((option) => ({
          value: option?._id,
          label: option?.name
        }));
        setMileStonesList(formattedPermissions);
      }
    } catch (error) {
      console.error('Error fetching milestones:', error);
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    // if (!validateTextInput(description).isValid) {
    //   if (!validateTextInput(description).cleanedValue) {
    //     newErrors.description = "Please enter description.";
    //   } else {
    //     newErrors.description = validateTextInput(description).message;
    //   }
    // }

    if (description && description.trim().length > 1500) {
      newErrors.description = 'Description must be less then 500 characters.';
    }

    if (!isGeneralFeedback && !selectedMilestone) {
      newErrors.milestone = 'Please select a milestone.';
    }

    // Update error handling for clients
    const clientErrors = clients.map((client) => (client.selectedClient ? null : 'Please select this client.'));

    if (clientErrors.some((error) => error !== null)) {
      newErrors.clients = clientErrors;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submissionInProgressRef.current) return;

    if (validateForm()) {
      submissionInProgressRef.current = true;
      setSubmitLoading(true);
      try {
        const payload = {
          milestoneId: selectedMilestone?.value,
          projectId,
          description,
          requestType: isGeneralFeedback ? 'general' : 'requested', // Fixed value
          clients: clients.map((client) => client.selectedClient?.value) // Array of client IDs
        };
        const response = await APIServices.post('/project-milestone-feedback', payload);
        if (response.message) {
          appToast(response.message, TOAST_TYPE.SUCCESS);
          closeModal();
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      } finally {
        submissionInProgressRef.current = false;
        setSubmitLoading(false);
      }
    }
  };

  const addClient = () => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      clients: null
    }));
    // Prevent adding a new client if the last one is not selected
    if (clients[clients.length - 1]?.selectedClient === null) {
      appToast('Please select the current client before adding a new one.', TOAST_TYPE.ERROR);
      return;
    }
    setClients((prevClients) => [...prevClients, { id: prevClients.length + 1, selectedClient: null }]);
  };

  const removeClient = (id) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      clients: null
    }));
    setClients((prevClients) => prevClients.filter((client) => client.id !== id));
  };

  const updateClientSelection = (id, selectedOption) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      clients: null
    }));

    setClients((prevClients) =>
      prevClients.map((client) => (client.id === id ? { ...client, selectedClient: selectedOption } : client))
    );
  };

  const getFilteredClientOptions = (currentClientId) => {
    // Exclude already selected clients from options for other rows
    const selectedClientValues = clients
      .filter((client) => client.id !== currentClientId && client.selectedClient)
      .map((client) => client.selectedClient.value);

    return clientOptions.filter((option) => !selectedClientValues.includes(option.value));
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="updatedSignOff-form">
          <div className="updatedSignOff-leftSec">
            <div className="row">
              <div className="col-lg-12">
                <div className="input-group feedback-type-group">
                  <div className={`ask-feedback-switch`}>
                    <h4>Do you want general feedback?</h4>
                    <div className="form-switch">
                      <input
                        type="checkbox"
                        checked={isGeneralFeedback}
                        onChange={(e) => {
                          const checked = e.target.checked;

                          setGeneralFeedback(checked);

                          // remove milestone selection
                          setSelectedMilestone(null);

                          // clear milestone + client errors
                          setErrors((prev) => ({
                            ...prev,
                            milestone: null,
                            clients: null
                          }));
                        }}
                        name="isGeneralFeedback"
                        hidden="hidden"
                        id="generalfeedback"
                        // disabled={isEditing}
                      />
                      <label className="switch" htmlFor="generalfeedback"></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {!isGeneralFeedback && (
              <div className="row mt-3">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label className="form-lable">Which milestone needs signing off?</label>
                    <Select
                      className={`form-control select2 ${errors.milestone ? 'form-invalid' : ''}`}
                      options={mileStonesList}
                      placeholder="Select Milestone"
                      isClearable
                      isLoading={loading}
                      value={selectedMilestone}
                      onChange={(option) => {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          milestone: null
                        }));
                        setSelectedMilestone(option);
                      }}
                    />
                    {errors.milestone && <small className="text-danger">{errors.milestone}</small>}
                  </div>
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-lg-12">
                <div className={`form-group ${isGeneralFeedback ? 'mt-3' : ''}`}>
                  <label className="form-lable">What would you like feedback on?</label>
                  <textarea
                    style={{ maxHeight: '320px' }}
                    placeholder="Describe what you want reviewed or any questions you have…"
                    className={`form-control ${errors.description ? 'form-invalid' : ''}`}
                    value={description}
                    onChange={(e) => {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        description: null
                      }));
                      setDescription(e.target.value);
                      e.target.style.height = 'auto'; // Reset the height
                      e.target.style.height = `${e.target.scrollHeight + 2}px`; // Set the height to fit content
                      setDescLength(e?.target?.value?.trim()?.length);
                    }}
                    maxLength={500}
                  />
                  <span style={{ float: 'right' }}>{`${descLength}/1500`}</span>
                  {errors.description && <small className="text-danger">{errors.description}</small>}
                </div>
              </div>
            </div>
            <button type="submit" className="btn-black" disabled={submitLoading}>
              {submitLoading ? selectLoader(35) : 'Submit'}
            </button>
          </div>

          <div className="updatedSignOff-righttSec">
            <div className="client-name">Notify Client</div>

            <div className="list">
              {/* Select All */}
              <div className="item">
                <div className="left">
                  <div className="name">All</div>
                </div>

                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={
                      clientOptions.length > 0 &&
                      clientOptions.every((client) => clients.some((c) => c.selectedClient?.value === client.value))
                    }
                    onChange={() => {
                      setErrors((prev) => ({
                        ...prev,
                        clients: null
                      }));
                      const isAllSelected =
                        clientOptions.length > 0 &&
                        clientOptions.every((client) => clients.some((c) => c.selectedClient?.value === client.value));

                      if (isAllSelected) {
                        setClients([{ id: 1, selectedClient: null }]);
                      } else {
                        setClients(
                          clientOptions.map((client, index) => ({
                            id: index + 1,
                            selectedClient: client
                          }))
                        );
                      }
                    }}
                  />
                  <span></span>
                </label>
              </div>

              {/* Client List */}
              {clientOptions.map((client) => {
                const isSelected = clients.some((c) => c.selectedClient?.value === client.value);

                return (
                  <div className="item" key={client.value}>
                    <div className="left">
                      <img src={client.profilePic || user} alt="User" className="avatar" />

                      <div className="name">{client.label}</div>
                    </div>

                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => {
                          // clear client error
                          setErrors((prev) => ({
                            ...prev,
                            clients: null
                          }));

                          if (isSelected) {
                            const updated = clients.filter((c) => c.selectedClient?.value !== client.value);

                            setClients(updated.length ? updated : [{ id: 1, selectedClient: null }]);
                          } else {
                            setClients((prev) => [
                              ...prev.filter((c) => c.selectedClient),
                              {
                                id: Date.now(),
                                selectedClient: client
                              }
                            ]);
                          }
                        }}
                      />
                      <span></span>
                    </label>
                  </div>
                );
              })}
            </div>

            {errors.clients && <small className="text-danger">Please select at least one client.</small>}
          </div>
        </div>
        {/* <div>
          <p className="client-head">Add Client</p>
          {clients.map((client, index) => (
            <div className="row" key={client.id}>
              <div className="col-lg-12">
                <div className="add-client-cover">
                  <div className="form-group client-group">
                    <Select
                      className="form-control"
                      options={getFilteredClientOptions(client.id)}
                      value={client.selectedClient}
                      onChange={(option) => updateClientSelection(client.id, option)}
                      placeholder="Select Client"
                    />
                  </div>
                  <div className="form-group btn-group client">
                    {clients.length > 1 && (
                      <button type="button" className="delete-btn" onClick={() => removeClient(client.id)}>
                        <img src={deleteBtn} alt="Delete" className="deleteBtn" />
                      </button>
                    )}
                    {index === clients.length - 1 && (
                      <button type="button" className="delete-btn" onClick={addClient}>
                        <img src={plusBtn} alt="Add" className="plusBtn" />
                      </button>
                    )}
                  </div>
                  {errors.clients && errors.clients[index] && (
                    <small className="text-danger">{errors.clients[index]}</small>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div> */}
      </form>
    </div>
  );
};

export default ReqFeedbackModal;
